import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const INSTAGRAM_OAUTH_BASE_URL = 'https://www.instagram.com/oauth/authorize';
const INSTAGRAM_APP_ID = '1256896625823782';
const INSTAGRAM_REDIRECT_URI = 'https://app.relif.com/InstagramIntegrationSuccess';
const INSTAGRAM_RESPONSE_TYPE = 'code';
const INSTAGRAM_SCOPES = [
  'instagram_business_basic',
  'instagram_business_manage_messages',
  'instagram_business_manage_comments',
  'instagram_business_content_publish',
  'instagram_business_manage_insights',
];

const InstagramIntegrationStart = () => {
  const integrationUrl = `${INSTAGRAM_OAUTH_BASE_URL}?force_reauth=true&client_id=${encodeURIComponent(
    INSTAGRAM_APP_ID
  )}&redirect_uri=${encodeURIComponent(INSTAGRAM_REDIRECT_URI)}&response_type=${encodeURIComponent(
    INSTAGRAM_RESPONSE_TYPE
  )}&scope=${encodeURIComponent(INSTAGRAM_SCOPES.join(','))}`;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 3,
          p: { xs: 4, md: 6 },
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
          Conectar Instagram con Relif
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            mb: 4,
          }}
        >
          Haz clic en el botón para iniciar el flujo de conexión con Instagram vía Facebook Login for Business.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          href={integrationUrl}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Conectar Instagram
        </Button>
      </Box>
    </Box>
  );
};

export default InstagramIntegrationStart;
